var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import { CheckIcon } from '../../icons';
import { styled } from '../../themeCustomink';
var StyledButton = styled('button')(function (_a) {
    var selected = _a.selected;
    return ({
        all: 'unset',
        position: 'absolute',
        top: '16px',
        right: '16px',
        display: 'grid',
        placeItems: 'center',
        width: '32px',
        height: '32px',
        borderRadius: '40px',
        cursor: 'pointer',
        backgroundColor: selected ? designTokens.color.blue.default.value : '#fff',
    });
});
export var CardSelectButton = forwardRef(function (_a, ref) {
    var _b = _a.selected, selected = _b === void 0 ? false : _b, buttonProps = __rest(_a, ["selected"]);
    var grey = designTokens.color.gray.disabled.value;
    return (React.createElement(StyledButton, __assign({}, buttonProps, { selected: selected, "data-testid": "CardSelectButton", ref: ref }),
        React.createElement(CheckIcon, { htmlColor: selected ? '#fff' : grey, fontSize: "small" })));
});
//# sourceMappingURL=CardSelectButton.js.map